import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Language } from '@core/enums/language';

/**
 * Focuses the first invalid form control in the form
 * @param form the form to check
 * @param el the element to focus
 */
export function focusInvalidFormControl(form: FormGroup, el: ElementRef): void {
  form.markAllAsTouched();
  for (const key of Object.keys(form.controls)) {
    if (form.controls[key].invalid) {
      const invalidControl = el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
      invalidControl.focus();
      return;
    }
  }
}

/**
 * Set the 'lang' and 'translate' attributes on the root HTML element
 *
 * @param language the language to set the attributes to. Does nothing if the language is null
 */
export function setHtmlLangAttribute(language: Language | null) {
  if (!language) {
    return;
  }

  const langAttribute = language.slice(0, 2);
  const html = document.querySelector('html');
  if (html) {
    html.setAttribute('lang', langAttribute);
    html.setAttribute('translate', langAttribute);
  }
}
